import match from 'ramda/src/match'
import reduce from 'ramda/src/reduce'
import replace from 'ramda/src/replace'
import split from 'ramda/src/split'
import prop from 'ramda/src/prop'

export default (template, props) => {
	if (typeof template === 'function') {
		return template(props)
	}
	if (template) {
		const templateRe = /\$\{(.*?)\}/g
		const matches = match(templateRe, template)
		return reduce((acc, item) => {
			const propName = prop(2, split(/(\{|\})/, item))
			const propValue = prop(propName, props)
			return replace(item, propValue, acc)
		}, template, matches)
	}
	return ''
}
